<script>
export default {
  components: {},
  props: {
    isClientProgram: {
      type: Boolean,
      required: true,
    },
    day: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    hasWorkout() {
      return this.day.workouts.some(
        (item) => item.hasWorkout || item.programWorkout_id
      );
    },
    hasNote() {
      return this.day.dayHasTrainerNote;
    },
    hasCheckin() {
      return this.day.checkIns.some((item) => item.scheduledCheckIn_id);
    },
  },
  mounted() {},
  methods: {
    addWorkout() {
      this.$emit('add-workout');
    },
    createNote() {
      this.$emit('create-note');
    },
    scheduleCheckin() {
      this.$emit('create-checkin');
    },
    requestCheckin() {
      this.$emit('create-checkin');
    },
    duplicateDayStart() {
      this.$emit('duplicate-day-start');
    },
    clearAllEvents() {
      this.$emit('clear-all-day-events');
    },
  },
};
</script>

<template>
  <ul>
    <li v-if="!hasWorkout" @click="addWorkout">
      <svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.18 7.87c2.032 0 3.678-1.761 3.678-3.935C7.858 1.762 6.212 0 4.181 0S.503 1.762.503 3.935c0 2.174 1.647 3.936 3.678 3.936zm0-2.66c.678 0 1.226-.595 1.226-1.33 0-.735-.548-1.33-1.225-1.33s-1.226.595-1.226 1.33c0 .735.549 1.33 1.226 1.33zM.125 10.03a2.07 2.07 0 00.172 1.77l5.737 9.528a1.694 1.694 0 002.487.467l9.845-7.607A4.974 4.974 0 0020.29 9.98l-.032-.577a4.186 4.186 0 00-3.726-3.932 4.279 4.279 0 00-4.018 1.872L7.387 15 2.786 9.304a1.487 1.487 0 00-2.555.428l-.107.297z" fill="#000"/></svg>
      <span>Add Workout</span>
    </li>
    <li
      v-if="isClientProgram"
      @click="createNote"
      :class="[{ disabled: hasNote }]"
    >
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.994 0A5.997 5.997 0 000 6c0 3.312 2.682 6 5.994 6A6.003 6.003 0 0012 6c0-3.312-2.688-6-6.006-6zM6 10.8A4.799 4.799 0 011.2 6c0-2.652 2.148-4.8 4.8-4.8 2.652 0 4.8 2.148 4.8 4.8 0 2.652-2.148 4.8-4.8 4.8zm3-6.3a.899.899 0 11-1.8 0 .899.899 0 111.8 0zm-5.1.9a.899.899 0 100-1.8.899.899 0 100 1.8zm5.166 1.8A3.298 3.298 0 016 9.3a3.298 3.298 0 01-3.066-2.1h6.132z" fill="#000"/></svg>
      <span>Create Note</span>
    </li>
    <li
      v-if="isClientProgram"
      @click="scheduleCheckin"
      :class="[{ disabled: hasCheckin }]"
    >
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.994 0A5.997 5.997 0 000 6c0 3.312 2.682 6 5.994 6A6.003 6.003 0 0012 6c0-3.312-2.688-6-6.006-6zM6 10.8A4.799 4.799 0 011.2 6c0-2.652 2.148-4.8 4.8-4.8 2.652 0 4.8 2.148 4.8 4.8 0 2.652-2.148 4.8-4.8 4.8zm3-6.3a.899.899 0 11-1.8 0 .899.899 0 111.8 0zm-5.1.9a.899.899 0 100-1.8.899.899 0 100 1.8zm5.166 1.8A3.298 3.298 0 016 9.3a3.298 3.298 0 01-3.066-2.1h6.132z" fill="#000"/></svg>
      <span>Schedule Check-in</span>
    </li>
    <li v-if="!isClientProgram" @click="requestCheckin">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.994 0A5.997 5.997 0 000 6c0 3.312 2.682 6 5.994 6A6.003 6.003 0 0012 6c0-3.312-2.688-6-6.006-6zM6 10.8A4.799 4.799 0 011.2 6c0-2.652 2.148-4.8 4.8-4.8 2.652 0 4.8 2.148 4.8 4.8 0 2.652-2.148 4.8-4.8 4.8zm3-6.3a.899.899 0 11-1.8 0 .899.899 0 111.8 0zm-5.1.9a.899.899 0 100-1.8.899.899 0 100 1.8zm5.166 1.8A3.298 3.298 0 016 9.3a3.298 3.298 0 01-3.066-2.1h6.132z" fill="#000"/></svg>
      <span>Request Check-in</span>
    </li>
    <!-- <li>
      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.38.2H1.22C.659.2.205.659.205 1.22L.2 10.4l2.04-2.04h7.14c.561 0 1.02-.459 1.02-1.02V1.22C10.4.659 9.941.2 9.38.2zM5.81 4.79H4.79V1.73h1.02v3.06zM4.79 6.83h1.02V5.81H4.79v1.02z" fill="#000"/></svg>
      <span>Schedule Notification</span>
    </li> -->
    <div class="divider-horizontal">&nbsp;</div>
    <li @click="duplicateDayStart">
      <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.876.4H2.296C1.053.4.034 1.43.034 2.69v16.037h2.264V2.691h13.579V.4zm3.394 4.582H6.823c-1.245 0-2.263 1.03-2.263 2.29V23.31c0 1.26 1.018 2.291 2.263 2.291H19.27c1.245 0 2.264-1.03 2.264-2.29V7.272c0-1.26-1.019-2.291-2.264-2.291zM6.823 23.309H19.27V7.273H6.823v16.036z" fill="#2F70DE"/></svg>
      <span>Duplicate</span>
    </li>
    <li @click="clearAllEvents">
      <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 1H14v2H0V1h3.5l1-1h5l1 1zM3 18c-1.1 0-2-.9-2-2V4h12v12c0 1.1-.9 2-2 2H3z" fill="#000"/></svg>
      <span>Clear All Events</span>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
// stylelint-disable selector-max-type
ul {
  @include calc-font-size(0.7);

  padding-bottom: 1rem;
  width: 100%;
}

.divider-horizontal {
  align-self: center;
  border-top: 1px solid white;
  height: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  opacity: 0.2;
  width: 80%;
}
.icon {
  height: 1.5rem;
  margin-right: 0.8rem;
  width: 1.8rem;
  path {
    fill: black;
  }
}

li {
  border-radius: $base-border-radius-md;
  cursor: pointer;
  padding: 0.4rem 1rem;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:hover {
    background-color: $color-heading-text;

    .icon {
      path {
        fill: $color-tooltip-calendar-bg;
      }
    }
  }

  &:first-child {
    padding-top: 1rem;

    &:hover {
      background-color: $color-heading-text;
      border-top-left-radius: $base-border-radius-md;
      border-top-right-radius: $base-border-radius-md;
    }
  }
  span {
    @include calc-font-size(0.7);

    font-weight: 800;
    letter-spacing: 0.116667px;
  }
}
</style>
